import { queryCommonBookGray } from './commonBookGray';
import { BOOKING_SCENE_TITLES } from './constants';
import i18n from '@/utils/i18n';

/**
 * 统一预订灰度启动器。返回false时由调用入口继续执行原有页面逻辑。
 * @param {Vue} vm 调用入口的Vue组件实例，用于访问全局统一容器
 * @param {Object} options 场景、预选房型/房间及容器标题等启动参数
 * @returns {Promise<Boolean>} true表示已打开统一工作台，false表示调用方应继续旧流程
 */
export async function openCommonBook(vm, options) {
  const enabled = await queryCommonBookGray();
  if (!enabled) return false;
  vm.$modal.open({
    ...options,
    title: options.title || i18n.t(BOOKING_SCENE_TITLES[options.bookingScene] || 'commonBook.commonBooking'),
    capabilityKey: 'COMMON_BOOK',
  });
  return true;
}
